// DS: i8.18
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const HelpCenter: React.FC<Props> = props => (
  <IconWrap {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM10.9727 17.5996H12.9727V15.5996H10.9727V17.5996ZM11.9727 6.40039C10.2747 6.40042 8.85909 7.60962 8.54004 9.21387L10.502 9.60547C10.6389 8.91814 11.2451 8.40042 11.9727 8.40039C12.8011 8.40039 13.4727 9.07196 13.4727 9.90039C13.4724 10.7286 12.8009 11.4004 11.9727 11.4004C11.4204 11.4004 10.9727 11.8481 10.9727 12.4004V14.2002H12.9727V13.2549C14.4182 12.8246 15.4725 11.4857 15.4727 9.90039C15.4727 7.96739 13.9057 6.40039 11.9727 6.40039Z" />
    </svg>
  </IconWrap>
);
HelpCenter.displayName = 'HelpCenter';

export default HelpCenter;
